import type {ConferenceApiModel} from '../../../api/conference';
import type {Nullable} from '../../utility-types';

import {currentUserStore} from '../../../api/user';

export const isMeConferenceHost = (conference?: Nullable<ConferenceApiModel>) =>
  conference?.moderator_id === currentUserStore.user?._id;
